module.exports = __webpack_public_path__ + "media/images/green_plus-f7fe422dad3169e3eaa5cdef7f1ac2ce.svg";